"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _resizeDetector = _interopRequireDefault(require("./resizeDetector"));
var _Popover = _interopRequireDefault(require("./Popover"));
var _styles = require("./styles");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const getWidthSum = arr => arr.reduce((a, b) => a + b, 0);
class Container extends _react.PureComponent {
  constructor(...args) {
    super(...args);
    this.state = {
      widths: [],
      containerWidth: 0,
      prevChildren: []
    };
    this.handleResize = (idx, element) => {
      const newWidths = [...this.state.widths];
      newWidths[idx] = element.offsetWidth;
      this.setState({
        widths: newWidths
      });
    };
    this.handleRef = node => {
      this.container = node;
    };
    this.renderChildBreadcrumbs = items => {
      const popupLinks = [];
      const childCount = _react.default.Children.count(items);
      const children = _react.default.Children.toArray(items);
      const widthCopy = [...this.state.widths];
      const overflowIndex = 1;
      const popoverTriggerWidth = 50;
      if (childCount && this.state.widths.length === childCount) {
        this.state.widths.forEach(() => {
          if (getWidthSum(widthCopy) + popoverTriggerWidth > this.state.containerWidth) {
            const targetElement = children[overflowIndex];
            if (targetElement) {
              widthCopy.splice(overflowIndex, 1);
              children.splice(overflowIndex, 1);
              popupLinks.push(targetElement.props);
            }
          }
        });
      }
      if (popupLinks.length > 0) {
        const PopoverComponent = _react.default.createElement(_Popover.default, {
          items: popupLinks,
          renderSeparator: children.length > overflowIndex
        });
        children.splice(overflowIndex, 0, PopoverComponent);
      }
      return children.map((itm, idx) => _react.default.cloneElement(itm, {
        key: idx
      }));
    };
    this.renderToHiddenNode = items => {
      const childCount = _react.default.Children.count(items);
      if (childCount) {
        return _react.default.Children.map(items, (child, index) => {
          if (index + 1 === childCount) {
            document.title = child.props.children;
          }
          return _react.default.cloneElement(child, {
            idx: index,
            onResize: this.handleResize
          });
        });
      }
      return null;
    };
  }
  componentDidMount() {
    if (this.container) {
      (0, _resizeDetector.default)('scroll').listenTo(this.container, element => {
        this.setState({
          containerWidth: element.offsetWidth
        });
      });
    }
  }
  static getDerivedStateFromProps(props, state) {
    if (state.prevChildren.length !== props.children.length) {
      return {
        widths: state.widths.splice(0, props.children.length),
        prevChildren: props.children
      };
    }
    return null;
  }
  componentWillUnmount() {
    if (this.container) {
      (0, _resizeDetector.default)('scroll').removeAllListeners(this.container);
    }
  }
  render() {
    return _react.default.createElement(_styles.Container, {
      ref: this.handleRef,
      className: this.props.className,
      "data-test-role": "breadcrumbs"
    }, this.renderChildBreadcrumbs(this.props.children), _react.default.createElement(_styles.HiddenNode, null, this.renderToHiddenNode(this.props.children)));
  }
}
var _default = exports.default = Container;